var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInConstructionState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7935 8.08508H2.00969C1.35389 8.08508 0.822266 8.61671 0.822266 9.27251V12.6115C0.822266 13.2673 1.35389 13.7989 2.00969 13.7989H10.7935C11.4493 13.7989 11.9809 13.2673 11.9809 12.6115V9.27251C11.9809 8.61671 11.4493 8.08508 10.7935 8.08508Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3638 8.08521H14.58C13.9242 8.08521 13.3926 8.61683 13.3926 9.27263V12.6116C13.3926 13.2674 13.9242 13.799 14.58 13.799H23.3638C24.0196 13.799 24.5512 13.2674 24.5512 12.6116V9.27263C24.5512 8.61683 24.0196 8.08521 23.3638 8.08521Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0728 0.942383H8.28899C7.63319 0.942383 7.10156 1.47401 7.10156 2.12981V5.4688C7.10156 6.1246 7.63319 6.65623 8.28899 6.65623H17.0728C17.7286 6.65623 18.2602 6.1246 18.2602 5.4688V2.12981C18.2602 1.47401 17.7286 0.942383 17.0728 0.942383Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0728 15.2286H8.28899C7.63319 15.2286 7.10156 15.7603 7.10156 16.4161V19.7551C7.10156 20.4109 7.63319 20.9425 8.28899 20.9425H17.0728C17.7286 20.9425 18.2602 20.4109 18.2602 19.7551V16.4161C18.2602 15.7603 17.7286 15.2286 17.0728 15.2286Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInConstructionState);
export default __webpack_public_path__ + "static/media/in-construction-state.8e45645a50d12d9189c388049c44a056.svg";
export { ForwardRef as ReactComponent };